import React, { useEffect, useState } from 'react'
import { getDatabase, ref, update,push,child,get} from "firebase/database";
import {app} from "../api.js";
import moment from 'moment';
import FileUp from './FileUp.js';
import '../App.css'

import { getAuth, signOut } from 'firebase/auth';
const auth = getAuth(app);


const db = getDatabase(app);
const dbRef = ref(getDatabase(app));

const Admin = (props) => {

  const color =(index)=>{
    if ((index+1)% 2===0) {
      return "white"
    } else {
      return "#D5FFFC"
    }
  }

  const [id, setid] = useState('none');

  useEffect(() => {
    setEntry({...Entry,file:id})
  }, [id])

  const [Email, setEmail] = useState('')
  const [EmailList, setEmailList] = useState([])


  const [Error, setError] = useState(null)
  const [Show, setShow] = useState(false)
  const [Data, setData] = useState([])

  const total=()=>{
    let dr = 0;
    let cr = 0;
    for (let i = 0; i <Data.length; i++) {
      if (Data[i].dr) {
        dr = dr+parseFloat(Data[i].dr)
      }
      if (Data[i].cr) {
        cr = cr+parseFloat(Data[i].cr) 
      }
    }

    return {dr:dr,cr:cr}
  }




const [Entry, setEntry] = useState({
  title:"",
  dr:0,
  cr:'',
  date:moment(new Date()).format('yyyy-MM-DD'),
  id:props.uid.uid,
  name:props.uid.displayName,
  email:'',
  file:id
})
  
  useEffect(() => {
    if (Email!=='') {
        get(child(dbRef, `mountbook/entry/`)).then((snapshot) => {
            if (snapshot.exists()) {
            setData(Object.values(snapshot.val()).filter((item)=>(item.email===Email)))
            } else {
              console.log("No data available");
            }
          }).catch((error) => {
            console.error(error);
          });
    }
    
if (EmailList.length<1) {
    get(child(dbRef, `mountbook/email/`)).then((snapshot) => {
        if (snapshot.exists()) {
        setEmailList(Object.values(snapshot.val()))
        } else {
          console.log("No data available");
        }
      }).catch((error) => {
        console.error(error);
      });
}

   
  }, [Email])

  const getx=()=>{
    get(child(dbRef, `mountbook/entry/`)).then((snapshot) => {
      if (snapshot.exists()) {
      setData(Object.values(snapshot.val()).filter((item)=>(item.email===Email)))
      } else {
        console.log("No data available");
      }
    }).catch((error) => {
      console.error(error);
    });
  }
  


const Addproduct=()=>{

    console.log(Entry)

  if (Entry.title!==''&&parseFloat(Entry.cr)>0) {
    const newPostKey = push(child(ref(db),  `mountbook/entry/`)).key;
              update(ref(db, 'mountbook/entry/'+ newPostKey+'/'), {...Entry,
        PushKey: newPostKey
      }).then(()=>{getx();setShow(false);setError(null)} );
  }else{
    setError('Enter Currect Data')
  }

  
  }

  const logout=()=>{
    signOut(auth).then(() => {
      // setAUser(false)
      // window.reload();
    }).catch((error) => {
      
    });
  }


  const [ShowUpdate, setShowUpdate] = useState(false)
  const [Amt, setAmt] = useState({
    title:"",
    dr:0,
    cr:'',
    id:props.uid.uid,
    name:props.uid.displayName,
    email:'',
    file:id
  })

  const updateMetadata=(e)=>{


    setAmt({
      title:e.title,
      dr:e.dr===0?0:e.dr,
      cr:e.cr===0?0:e.cr,
      id:e.id,
      name:e.name,
      email:e.email,
      file:e.file,
      PushKey:e.PushKey
    })
    
  }

  const runupdatecode=()=>{
                update(ref(db, 'mountbook/entry/'+ Amt.PushKey+'/'), Amt).then(()=>{getx();setAmt({
                  title:''
                })} );
  }

  // (item.file).length>5&&window.open(item.file)


  return (
    <div>

<div style={{
      display:'flex',
      backgroundColor:'#6EE788',
      boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
      alignItems:'center',
      justifyContent:'space-between',
      padding:'0px 10px',
  }}>
      <div >
          <h1 style={{
              color:'black',
              fontSize:22,
              fontWeight:700
          }}>MountBook</h1>

      </div>

      <div style={{
        fontSize:16,
        margin:0,
       
        padding:10,
        color:'#972C2C'
      }}>
        <p style={{margin:0,padding:0,fontWeight:'bold'}}>Balance - ₹ {total().cr-total().dr}</p>
      </div>

      <div>
        
      <i style={
          {
              padding:10,
              backgroundColor:'#EAEAEA',
              borderRadius:20,
          }
      } onClick={logout} className="fa-solid fa-right-from-bracket"></i>
      </div>
  </div>

      <div style={{
        width:60,
        height:60,
        display:'flex',
        alignItems:'center',
        justifyContent:'center',
        backgroundColor:'#2989D8',
        borderRadius:40,
        position:'fixed',
        bottom:30,
        right:30
      }} onClick={()=>setShow(true)}>
      <i style={{
        fontSize:20,
        color:'white'
      }} class="fa-solid fa-plus"></i>
      </div>

<div style={{
    textAlign:'center',
    margin:'20px 0px'
}}>
<select style={{
    width:'80%'
}} type='email' value={Email} placeholder='Enter Email' onChange={(e)=>setEmail(e.target.value)}>
  <option value="">-Select Email-</option>
  {
    EmailList.map((item)=>(
<option value={item.email}>{item.email}</option>
    ))
  }
  

</select>

</div>
      

      <table style={{
        width:'100%',
        fontSize:12
      }}>
  <tr style={{
    backgroundColor:'#6EE788'
  }}>
    <th style={{width:'5%',padding:'8px 0px'}}>Sno.</th>
    <th style={{width:'20%'}}>Date</th>
    <th style={{width:'30%'}}>Perticular</th>
    <th style={{width:'20%'}}>Dr</th>
    <th style={{width:'20%'}}>Cr</th>
  </tr>

{
  Data.map((item,index)=>(
    <tr style={{backgroundColor:color(index+1)}}  onClick={()=>updateMetadata(item)}>
    <td style={{padding:'5px 0px',textAlign:'center'}}>{index+1}</td>
    <td>{moment(item.date).format('DD-MM-yyyy')}</td>
    <td>{item.title}</td>
    <td>{item.dr}</td>
    <td>{item.cr}</td>
  </tr>
  ))
}

{
  Data.length>0&&<tr style={{backgroundColor:'#52FDCE'}}>
    <td style={{padding:'5px 0px',textAlign:'center'}}></td>
    <td></td>
    <td style={{padding:'8px 0px',textAlign:'center'}}>Total</td>
    <td>{total().dr}</td>
    <td>{total().cr}</td>
  </tr>
}

</table>

{Amt.title!==''&&
<div style={{
  position:'fixed',
  bottom:0,
  right:0,
  left:0,
  alignItems:'center',
  backgroundColor:'white',
  padding:20,
  fontSize:12,
  display:'flex',
  flexDirection:'column'
}}>

  <h4 style={{marginBottom:20,marginTop:20}}>Modify Entry</h4>

<span>Perticular</span>
<input style={{
  padding:10,
  width:'80%',
  margin:'5px 0px'
}} type='text' placeholder='Enter Perticular' value={Amt.title} onChange={(e)=>setAmt({...Amt,title:e.target.value})}/>
<span>Dr Amount</span>
<input style={{
  padding:10,
  width:'80%',
  margin:'5px 0px'
}} type='number' placeholder='Enter Dr Side Amount' value={Amt.dr} onChange={(e)=>setAmt({...Amt,dr:e.target.value})}/>
<span>Cr Amount</span>
<input style={{
  padding:10,
  width:'80%',
  margin:'5px 0px'
}} type='number' placeholder='Enter Cr Side Amount' value={Amt.cr} onChange={(e)=>setAmt({...Amt,cr:e.target.value})}/>
<button style={{
  padding:10,
  width:'87%',
  margin:'5px 0px'
}} onClick={runupdatecode}>Modify Entry</button>
<button style={{
  padding:10,
  width:'87%',
  margin:'5px 0px'
}} onClick={()=>setAmt({
  title:''
})}>Cancel</button>

{(Amt.file).length>5&&<a href={Amt.file}>View Image</a>}

</div>}

{Show&&
<div style={{
  position:'fixed',
  right:20,
  left:20,
  padding:20,
  textAlign:'center',
  bottom:20,
  backgroundColor:'white',
  border:'1px solid black'
}}>
{Error&&<p style={{fontSize:12,color:'red'}}>{Error}</p>}
<input style={{
  padding:10,
  width:'80%',
  margin:'5px 0px'
}} type='date' value={Entry.date} placeholder='Enter Perticular' onChange={(e)=>setEntry({...Entry,date:e.target.value})}/>
<input style={{
  padding:10,
  width:'80%',
  margin:'5px 0px'
}} type='text' placeholder='Enter Perticular' onChange={(e)=>setEntry({...Entry,title:e.target.value})}/>
<input style={{
  padding:10,
  width:'80%',
  margin:'5px 0px'
}} type='number' placeholder='Amount' onChange={(e)=>setEntry({...Entry,cr:e.target.value})}/>

<select style={{
    width:'80%',
    margin:'5px 0px'
}} type='email' value={Entry.email} placeholder='Enter Email' onChange={(e)=>setEntry({...Entry,email:e.target.value})}>
  <option value="">-Select Email-</option>
  {
    EmailList.map((item)=>(
<option value={item.email}>{item.email}</option>
    ))
  }
  </select>
{/* <input style={{
  padding:10,
  width:'80%',
  margin:'5px 0px',
  border:'1px solid black'
}} type='file' placeholder='Amount' onChange={(e)=>setEntry({...Entry,file:e.target.value})}/> */}

<FileUp x = {id} setX={setid} title='Receipt'/>

<button style={{
  padding:10,
  width:'87%',
  margin:'5px 0px'
}} onClick={Addproduct}>Add Entry</button>

<button style={{
  padding:10,
  width:'87%',
  margin:'5px 0px'
}} onClick={()=>setShow(false)}>Back</button>

</div>

}

    </div>
  )
}

export default Admin
